import { nanoid } from 'nanoid'
import { TICKS_PER_LOOP } from '../../constants'
import { StemType } from '../../types'
import {
  booleanArray2DToNoteCollection,
  booleanArrayToNoteCollection
} from './StemSerializationUtils'

/** Migrates from a single type of StemStore two typed stem stores: DrumStemStore and MelodicStemStore. */
export const stemMigration2to3 = (v2Stem: any) => {
  const typedStem = {
    loops: v2Stem.loops,
    stemSettings: v2Stem.stemSettings,
    isRemixed: v2Stem.isRemixed,
    remixedContractId: v2Stem.remixedContractId,
    remixedStemId: parseInt(v2Stem.remixedStemId || -1),
    remixedOgSongName: v2Stem.remixedOgSongName,
    remixedOgArtist: v2Stem.remixedOgArtist,
    colorIndex: v2Stem.colorIndex,
    isSolo: v2Stem.isSolo
  }

  if (v2Stem.isDrums) {
    const drumStem = Object.assign({
      drumSamples: v2Stem.drumSamples,
      drumGains: v2Stem.drumGains,
      stemType: StemType.DRUMS,
      version: 3,
      ...typedStem
    })
    return drumStem
  } else {
    const instrumentStem = Object.assign({
      melodicSample: v2Stem.melodicSample,
      stemType: StemType.INSTRUMENT,
      version: 3,
      ...typedStem
    })
    return instrumentStem
  }
}

/** Replaces SampleStore with an integer sampleIndex and adds uniqueId. */
export const stemMigration3to4 = (v3Stem: any) => {
  if (v3Stem.stemType === StemType.DRUMS) {
    const newSamples = v3Stem.drumSamples.map((drumSample) => {
      return {
        ...drumSample,
        sampleIndex: drumSample.sample.id,
        sample: undefined
      }
    })
    return {
      ...v3Stem,
      drumSamples: newSamples,
      version: 4,
      uniqueId: v3Stem.uniqueId || nanoid()
    }
  } else if (v3Stem.stemType === StemType.INSTRUMENT) {
    const newSample = {
      ...v3Stem.melodicSample,
      sampleIndex: v3Stem.melodicSample?.sample?.id,
      sample: undefined
    }
    return {
      ...v3Stem,
      melodicSample: newSample,
      version: 4,
      uniqueId: v3Stem.uniqueId || nanoid()
    }
  }
  throw 'unsupported stem type'
}

/** LZW compression -> Gzip compression. No change to format */
export const stemMigration4to5 = (v4Stem: any) => {
  return { ...v4Stem, version: 5 }
}

/**
 *  Converts NoteRow -> NoteCollection. Make sure to deep clone the object to not modify the original.
 */
export const stemMigration5to6 = (v5Stem: any) => {
  // Deep clone the object
  const v6Stem = JSON.parse(JSON.stringify(v5Stem))
  v6Stem.version = 6

  v6Stem.loops.forEach((loop) => {
    loop.drumLoop.subLoops.forEach((subLoop) => {
      const noteRow = subLoop.noteRow
      const notes = booleanArrayToNoteCollection(noteRow.notes)
      subLoop.notes = notes
      delete subLoop.noteRow
    })
  })
  v6Stem.loops.forEach((loop) => {
    const melodicLoop = loop.melodicLoop
    const noteRows = melodicLoop.noteRows.map((item) => (item === null ? null : item.notes))
    const notes = booleanArray2DToNoteCollection(
      noteRows,
      TICKS_PER_LOOP / 4,
      v6Stem.melodicSample?.autoRelease
    )
    melodicLoop.notes = notes
    delete melodicLoop.noteRows
  })
  return v6Stem
}
